import React from "react";
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

const ColumnDefinitions = () => {
  // Sample column definitions data - you can replace this with actual data
  const columnDefinitions = [
    {
      column1: "Delivery Performance - Service Times",
      column2: "StartTime (Local)",
      column3: "The timestamp of when a lift entered the stop's geofence, in the DC's local timezone.",
    },
    {
      column1: "Delivery Performance - Service Times", 
      column2: "EndTime (Local)",
      column3: "The timestamp of when a lift was last recorded inside the stop's geofence, in the DC's local timezone.",
    },
    {
      column1: "Delivery Performance - Service Times",
      column2: "Service Time ",
      column3: "The difference in time between entering and exiting the geofence of the stop location. Service time includes the cumulative durations of pre-idle, post-idle, and active time.", 
    },
    {
      column1: "Delivery Performance - Service Times",
      column2: "Manifest Time (if populated)",
      column3: "If a customer sends us 'manifest' data through our API connection, we use the specific 'manifest time' or 'expected time' provided.",
    },
    {
      column1: "Delivery Performance - Service Times",
      column2: "Historical Stop Time",
      column3: "A Historical Stop Time uses averages based on the specific route number. We take the historical times for that route over the last three months or less and calculate the average based on those values.",
    },
    {
      column1: "Delivery Performance - Service Times",
      column2: "Case/SKU counts ",
      column3: (
        <Box>
          <div>Case count – the number of cases to be delivered to a specific stop.</div>
          <div>SKU count – the number of unique SKUs to be delivered to a specific stop.</div>
        </Box>
      ),
    }
  ];

  return (
    <Box sx={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}>
      <Typography variant="h4" sx={{ marginBottom: "20px", color: "primary.main" }}>
        Service Times - Column Definitions
      </Typography>

      <TableContainer component={Paper} sx={{ boxShadow: 2 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "primary.light" }}>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Page</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Column Label</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Definition</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {columnDefinitions.map((def, index) => (
              <TableRow key={index} sx={{ '&:nth-of-type(odd)': { backgroundColor: 'grey.50' } }}>
                <TableCell sx={{ fontWeight: "medium" }}>{def.column1}</TableCell>
                <TableCell>{def.column2}</TableCell>
                <TableCell>{def.column3}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ColumnDefinitions;
